import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-285">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-286">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-287">
          <h3 className="text-2xl font-heading font-bold text-white mb-4 tracking-tight" data-id="element-288">
            SyNeural
          </h3>
          <p className="text-sm leading-relaxed" data-id="element-289">
            Building better judgment for a more capable society.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-290">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-291">
            Platform
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-292">
            <li data-id="element-293">
              <a href="#cji" className="hover:text-white transition-colors" data-id="element-294">
                CJI
              </a>
            </li>
            <li data-id="element-295">
              <a href="#ncji" className="hover:text-white transition-colors" data-id="element-296">
                NCJI
              </a>
            </li>
            <li data-id="element-297">
              <a href="#solutions" className="hover:text-white transition-colors" data-id="element-298">
                Solutions
              </a>
            </li>
            <li data-id="element-299">
              <a href="#home" className="hover:text-white transition-colors" data-id="element-300">
                Platform Overview
              </a>
            </li>
          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-301">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-302">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-303">
            <li data-id="element-304">
              <a href="#" className="hover:text-white transition-colors" data-id="element-305">
                Education
              </a>
            </li>
            <li data-id="element-306">
              <a href="#" className="hover:text-white transition-colors" data-id="element-307">
                Employers
              </a>
            </li>
            <li data-id="element-308">
              <a href="#" className="hover:text-white transition-colors" data-id="element-309">
                Civil Society
              </a>
            </li>
            <li data-id="element-310">
              <a href="#" className="hover:text-white transition-colors" data-id="element-311">
                Government
              </a>
            </li>
            <li data-id="element-312">
              <a href="#" className="hover:text-white transition-colors" data-id="element-313">
                Leadership Development
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-314">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-315">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-316">
            <li data-id="element-317">
              <a href="#about" className="hover:text-white transition-colors" data-id="element-318">
                About
              </a>
            </li>
            <li data-id="element-319">
              <a href="#research" className="hover:text-white transition-colors" data-id="element-320">
                Research
              </a>
            </li>
            <li data-id="element-321">
              <a href="#partnerships" className="hover:text-white transition-colors" data-id="element-322">
                Partnerships
              </a>
            </li>
            <li data-id="element-323">
              <a href="#contact" className="hover:text-white transition-colors" data-id="element-324">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-325">
        <p data-id="element-326">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-327">
          <a href="#privacy" className="hover:text-white transition-colors" data-id="element-328">
            Privacy Policy
          </a>
          <a href="#terms" className="hover:text-white transition-colors" data-id="element-329">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}